import { render } from "./SuccessCollection.vue?vue&type=template&id=155a2fc2&scoped=true"
import script from "./SuccessCollection.vue?vue&type=script&lang=js"
export * from "./SuccessCollection.vue?vue&type=script&lang=js"

import "./SuccessCollection.vue?vue&type=style&index=0&id=155a2fc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-155a2fc2"]])

export default __exports__